import { render, staticRenderFns } from "./MultipleSend.vue?vue&type=template&id=1c300998&"
import script from "./MultipleSend.vue?vue&type=script&lang=js&"
export * from "./MultipleSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports